/**
 * @generated SignedSource<<6d18c53e08307aa89cbd7c082e5b4c27>>
 * @relayHash 2537091eb127b5923dbfcb2396cdbd38
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2537091eb127b5923dbfcb2396cdbd38

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteGeneralAttestationInput = {
  id: string;
};
export type useChDeleteGeneralAttestationMutation$variables = {
  input: Ch_deleteGeneralAttestationInput;
};
export type useChDeleteGeneralAttestationMutation$data = {
  readonly ch_deleteGeneralAttestation: {
    readonly ch_GeneralAttestation: {
      readonly id: string;
    } | null;
  };
};
export type useChDeleteGeneralAttestationMutation = {
  response: useChDeleteGeneralAttestationMutation$data;
  variables: useChDeleteGeneralAttestationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeleteGeneralAttestationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteGeneralAttestationPayload",
        "kind": "LinkedField",
        "name": "ch_deleteGeneralAttestation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_GeneralAttestation",
            "kind": "LinkedField",
            "name": "ch_GeneralAttestation",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeleteGeneralAttestationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteGeneralAttestationPayload",
        "kind": "LinkedField",
        "name": "ch_deleteGeneralAttestation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_GeneralAttestation",
            "kind": "LinkedField",
            "name": "ch_GeneralAttestation",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "2537091eb127b5923dbfcb2396cdbd38",
    "metadata": {},
    "name": "useChDeleteGeneralAttestationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "9a0a8c1f80b99ee00fcf50fac03414a4";

export default node;
